import arrowLeft from '~/assets/icons/arrow_left_2.svg';
import cross from '~/assets/icons/cross.svg';
import { CollectionImage } from '~/components/collections';
import {
	NumberPlatePreviewSize,
	NumberplatePreview,
} from '~/components/ui/NumberplatePreview';
import { VehicleNumberPlateType } from '~/shared';
import { setReportVisible, useLayoutDispatch } from '../../redux';
import { TextLabel } from '../TextLabel';
import { VehicleState } from '../VehicleState';
import { TuningTypes, tuningData } from './AppAdsReport.model';
import {
	StyledBackButton,
	StyledContainer,
	StyledCrossButton,
	StyledHeadContainer,
	StyledInfoHint,
	StyledInfoHintContainer,
	StyledMainContainer,
	StyledPhotoContainer,
	StyledStateContainer,
	StyledTable,
	StyledTuningContainer,
	StyledTuningGrid,
	StyledTuningItem,
} from './AppAdsReport.styled';

const AppAdsReport = () => {
	const dispatch = useLayoutDispatch();
	return (
		<StyledContainer>
			<StyledHeadContainer>
				<StyledBackButton onClick={() => dispatch(setReportVisible(false))}>
					<img src={arrowLeft} />
					<TextLabel>Вернуться назад</TextLabel>
				</StyledBackButton>
				<TextLabel
					style={{
						fontSize: 14,
						color: '#ffffff',
						opacity: 0.5,
						textAlign: 'center',
					}}
				>
					Mercedes E63s AMG (Отчёт №778)
				</TextLabel>
				<StyledCrossButton onClick={() => dispatch(setReportVisible(false))}>
					<img src={cross} />
				</StyledCrossButton>
			</StyledHeadContainer>
			<StyledMainContainer>
				<StyledPhotoContainer>
					<CollectionImage
						collection={'vehicles'}
						id={'gaz_2410'}
						size={'md'}
					/>
					<StyledInfoHintContainer $position={'left'}>
						<StyledInfoHint>
							<TextLabel>11:22</TextLabel>
						</StyledInfoHint>
					</StyledInfoHintContainer>
					<StyledInfoHintContainer $position={'right'}>
						<NumberplatePreview
							numberPlate={{
								type: VehicleNumberPlateType.Classic,
								text: 'A111AA',
								region: '38',
							}}
							size={NumberPlatePreviewSize.Size20}
						/>
					</StyledInfoHintContainer>
				</StyledPhotoContainer>
				<TextLabel
					style={{
						fontSize: 14,
						color: '#ffffff',
						opacity: 0.5,
						textAlign: 'center',
						marginTop: 17,
					}}
				>
					Информация о транспорте
				</TextLabel>
				<StyledTable>
					<TextLabel>Марка / Модель</TextLabel>
					<TextLabel>Mercedes E63s AMG</TextLabel>
					<TextLabel>Пробег</TextLabel>
					<TextLabel>
						240 000 <span>км.</span>
					</TextLabel>
					<TextLabel>Номер кузова</TextLabel>
					<TextLabel>24040000000004</TextLabel>
					<TextLabel>Кол-во владельцев</TextLabel>
					<TextLabel>
						18 <span>Владельцев</span>
					</TextLabel>
					<TextLabel>Владелец</TextLabel>
					<TextLabel>a.bakhia</TextLabel>
					<TextLabel>Цвет</TextLabel>
					<TextLabel>Перламутровый</TextLabel>
				</StyledTable>
				<TextLabel
					style={{
						fontSize: 14,
						color: '#ffffff',
						opacity: 0.5,
						textAlign: 'center',
						marginTop: 29,
					}}
				>
					Состояние транспорта
				</TextLabel>
				<StyledStateContainer>
					<VehicleState />
				</StyledStateContainer>
				<StyledTuningContainer>
					<TextLabel>Установленный тюнинг</TextLabel>
					<StyledTuningGrid>
						{Object.values(TuningTypes).map((item, index) => (
							<StyledTuningItem $active={index % 2 === 1} key={index}>
								<img src={tuningData[item].img} />
								<TextLabel>{tuningData[item].label}</TextLabel>
							</StyledTuningItem>
						))}
					</StyledTuningGrid>
				</StyledTuningContainer>
			</StyledMainContainer>
		</StyledContainer>
	);
};

export { AppAdsReport };
